import { render } from "./operationLogList.vue?vue&type=template&id=84475e54&scoped=true&ts=true"
import script from "./operationLogList.vue?vue&type=script&lang=ts"
export * from "./operationLogList.vue?vue&type=script&lang=ts"

import "./operationLogList.vue?vue&type=style&index=0&id=84475e54&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84475e54"]])

export default __exports__